import script from "./GridCargoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridCargoComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridCargoComponent.vue?vue&type=style&index=0&id=3e18d18d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e18d18d"]])

export default __exports__